// ============================================================
// executionLog — エージェント tool 実行の永続ログ（Track A1, 2026-07-04）
//
// tool 実行のたびに fire-and-forget でサーバー（agent_execution_logs）へ記録する。
// 記録失敗は本体機能に影響させない（console.warn のみ）。
// レビュー UI: src/pages/AiAgentLog.tsx（good/bad 評価 → 改善ルール化の入口）
// ============================================================

import { postAgentAction } from './api';

export interface AgentExecutionRecord {
  session_id?: string;
  /** 'agent'（グローバルエージェント） | 'email'（メール生成の接地tool） */
  source: 'agent' | 'email';
  tool_name: string;
  args?: Record<string, any>;
  result_status: 'success' | 'error' | 'cancelled';
  result_summary?: string;
  reservation_id?: string | number | null;
  duration_ms?: number;
}

/** 実行ログを非同期送信（待たない・失敗しても投げない） */
export function recordAgentExecution(record: AgentExecutionRecord): void {
  try {
    void postAgentAction('log_execution', {
      session_id: record.session_id || '',
      source: record.source,
      tool_name: record.tool_name,
      args_json: safeStringify(record.args, 4000),
      result_status: record.result_status,
      result_summary: (record.result_summary || '').slice(0, 2000),
      reservation_id: record.reservation_id != null ? String(record.reservation_id) : '',
      duration_ms: record.duration_ms ?? null,
    }).catch((e) => {
      // eslint-disable-next-line no-console
      console.warn('[executionLog] 記録失敗（本体処理には影響しません）:', e?.message || e);
    });
  } catch {
    /* ignore */
  }
}

/** tool 結果から result_status を判定（tools.ts の返却規約に準拠） */
export function toResultStatus(result: any): 'success' | 'cancelled' | 'error' {
  if (result && result.cancelled) return 'cancelled';
  if (result && result.success === false) return 'error';
  return 'success';
}

/** tool 結果の要約文字列（ログ表示用） */
export function summarizeToolResult(result: any): string {
  if (result == null) return '';
  if (typeof result === 'string') return result.slice(0, 500);
  if (result.error) return String(result.error).slice(0, 500);
  return safeStringify(result, 500);
}

function safeStringify(value: any, maxLen: number): string {
  try {
    const s = JSON.stringify(value ?? {});
    return s.length > maxLen ? `${s.slice(0, maxLen - 1)}…` : s;
  } catch {
    return '';
  }
}

/** 会話セッションID の生成（useAgent が会話ごとに払い出す） */
export function newSessionId(): string {
  return `sess_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}
